import React from 'react';
import {Box, Button} from '@mui/material';
import PropTypes from 'prop-types';
import AlertIcon from 'asset/imageV2/icon_alert.svg';
const ItemView = props => {
  if (!props.visibility) {
    return <></>;
  }
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 5,
        backgroundColor: 'rgba(55,55,55,0.5)',
      }}
    >
      <Box
        style={{
          width: '28rem',
          textAlign: 'left',
          borderRadius: '20px',
          background: 'white',
          paddingLeft: '3rem',
          paddingRight: '3rem',
          paddingBottom: '2rem',
          paddingTop: '1rem',
          color: 'black',
        }}
      >
        <Box
          style={{
            fontSize: '1.7rem',
            fontWeight: 'bold',
            marginBottom: '3rem',
            marginTop: '0.5rem',
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'center',
          }}
        >
          필수 조건이 만족되지 않았습니다!
        </Box>
        <Box
          style={{
            display:
              props.textCountChecked &&
              (props.currentCount < props.textCountMin ||
                props.currentCount > props.textCountMax)
                ? 'flex'
                : 'none',
            alignItems: 'center',
            gap: '0.5rem',
            marginTop: '0.5rem',
          }}
        >
          <img src={AlertIcon} alt="AlertIcon" />
          <span style={{color: 'red'}}>
            {'글자수 : ' + props.currentCount + '자'}
          </span>
          <span>
            {'(조건 : ' +
              props.textCountMin +
              '자 ~ ' +
              props.textCountMax +
              '자)'}
          </span>
        </Box>
        <Box
          style={{
            display:
              props.requiredWordChecked &&
              0 !=
                props.unfoundRequiredWord.split(',').filter(val => val != '')
                  .length
                ? 'flex'
                : 'none',
            alignItems: 'center',
            gap: '0.5rem',
            marginTop: '0.5rem',
          }}
        >
          <img src={AlertIcon} alt="AlertIcon" />
          <span style={{color: 'red'}}>
            {'빠진 키워드 : ' + props.unfoundRequiredWord.replace(',', ', ')}
          </span>
          <span>
            {'(조건 : ' + props.requiredWord.replace(',', ', ') + ')'}
          </span>
        </Box>

        <Box
          style={{
            marginTop: '2rem',
            borderTop: '2px dotted #717171',
          }}
        ></Box>
        <Box style={{marginTop: '1rem', fontWeight: '500'}}>
          조건을 충족하지 않았지만, 과제의 제출 기한이 지나서 이대로 제출할 수
          있습니다.
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '2rem',
          }}
        >
          <Button
            style={{
              width: '100%',
              whiteSpace: 'nowrap',
              color: ' #35D2BB',
              backgroundColor: 'white',
              fontSize: '1.125rem',
              fontWeight: 'bold',
              padding: '0.9rem 0rem',
              marginLeft: '1rem',
              borderRadius: '6.25rem',
              border: '1px solid #35D2BB',
            }}
            onClick={() => props.submitLateInvalidCancel()}
          >
            수정
          </Button>
          <Button
            style={{
              width: '100%',
              whiteSpace: 'nowrap',
              color: 'white',
              backgroundColor: 'red',
              fontSize: '1.125rem',
              fontWeight: 'bold',
              padding: '0.9rem 0rem',
              marginLeft: '1rem',
              borderRadius: '6.25rem',
            }}
            onClick={() => props.submitLateInvalidConfirm()}
          >
            제출
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
ItemView.propTypes = {
  visibility: PropTypes.bool,
  taskID: PropTypes.number,
  textCountChecked: PropTypes.bool,
  textCountMin: PropTypes.number,
  textCountMax: PropTypes.number,
  currentCount: PropTypes.number,
  requiredWordChecked: PropTypes.bool,
  requiredWord: PropTypes.string,
  unfoundRequiredWord: PropTypes.string,
  submitLateInvalidCancel: PropTypes.func,
  submitLateInvalidConfirm: PropTypes.func,
};
export default ItemView;
